"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharterIndexLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const visually_hidden_1 = require("./visually-hidden");
const CharterIndexLogoWrapper = ({ className, children, dangerouslySetInnerHTML }) => ((0, jsx_runtime_1.jsx)("div", { className: className, dangerouslySetInnerHTML: dangerouslySetInnerHTML, children: children }));
const CharterIndexRoot = (0, styles_1.styled)(CharterIndexLogoWrapper)(({ theme, color, size }) => (0, styles_1.css) `
	fill: inherit;
	${color === 'black' && 'fill: black;'}
	${color === 'white' && 'fill: white;'}
	${color === 'brand' && `fill: ${theme.palette.brand.main};`}

	svg {
		height: ${theme.spacing(2.4)};
		${size === 'md' && `height: ${theme.spacing(3)};`}
		${size === 'lg' && `height: ${theme.spacing(4)};`}
		
		width: auto;
	}
`);
const CharterIndexLogo = (p) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CharterIndexRoot, { ...p, dangerouslySetInnerHTML: p.iconOnly ? LOGO_ICON_ONLY : LOGO_WITH_TEXT }), (0, jsx_runtime_1.jsx)(visually_hidden_1.VisuallyHidden, { text: p.alt ?? 'Charter Index' })] }));
};
exports.CharterIndexLogo = CharterIndexLogo;
const LOGO_WITH_TEXT = { __html: `
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 769.722 54.418" enable-background="new 0 0 769.722 54.418" alt="">
	<g>
		<path fill="inherit" d="M205.29,46.66c-6.655,5.298-14.18,7.758-21.708,7.758c-19.384,0-24.345-13.344-21.125-26.912
			C165.696,13.863,177.931,0,196.792,0c7.081,0,13.139,2.68,17.221,7.978l-8.099,6.332c-2.615-3.353-6.855-4.919-11.403-4.919
			c-12.6,0-20.32,9.391-22.364,18.115c-2.024,8.645,0.78,17.668,13.679,17.668c4.546,0,10.14-1.866,14.403-5.298L205.29,46.66z"/>
		<path fill="inherit" d="M244.747,53.298l5.125-21.1h-25.646l-5.125,21.1h-9.837l12.667-52.185h9.84l-5.334,21.994h25.643
			l5.337-21.994h9.767l-12.67,52.185H244.747z"/>
		<path fill="inherit" d="M303.208,43.382h-27.282l-6.864,9.843h-10.657L294.478,1.04h10.737l10.739,52.185h-10.737L303.208,43.382z
			M297.187,11.997l-15.084,22.22h19.381L297.187,11.997z"/>
		<path fill="inherit" d="M366.638,53.225h-11.704l-10.971-17.447h-9.47l-4.232,17.447h-9.843l12.687-52.258
			c8.274,0,16.532,0.073,24.809,0.073c12.28,0.073,16.775,8.277,14.584,17.295c-1.736,7.158-6.771,14.389-17.176,16.401l11.48,17.815
			L366.638,53.225z M340.701,10.211l-4.054,16.701h14.985c6.262,0,9.957-4.179,10.974-8.351c1.012-4.179-0.732-8.351-6.92-8.351
			H340.701z"/>
		<path fill="inherit" d="M396.959,9.984h-16.552l2.174-8.944c15.059,0,27.806,0,42.938,0l-2.172,8.944h-16.548l-10.5,43.24h-9.84
			L396.959,9.984z"/>
		<path fill="inherit" d="M457.722,53.225h-39.064c4.219-17.368,8.455-34.816,12.67-52.185h39.065l-2.317,9.544h-29.299
			l-2.914,12.003h28.254l-2.225,9.165h-28.254l-2.858,11.782h29.296L457.722,53.225z"/>
		<path fill="inherit" d="M511.615,53.225h-11.707l-10.971-17.447h-9.467l-4.234,17.447h-9.841l12.687-52.258
			c8.275,0,16.529,0.073,24.807,0.073c12.283,0.073,16.775,8.277,14.59,17.295c-1.742,7.158-6.773,14.389-17.18,16.401l11.479,17.815
			L511.615,53.225z M485.677,10.211l-4.053,16.701h14.984c6.26,0,9.957-4.179,10.973-8.351c1.012-4.179-0.732-8.351-6.922-8.351
			H485.677z"/>
	</g>
	<g>
		<path fill="inherit" d="M539.765,53.225L552.433,1.04h9.766l-12.67,52.185H539.765z"/>
		<path fill="inherit" d="M605.75,0.967h9.838l-12.684,52.258h-6.111l-0.02,0.073L577.9,18.035l-8.541,35.189h-9.84L572.187,1.04
			h7.975l17.715,32.356L605.75,0.967z"/>
		<path fill="inherit" d="M664.285,26.686c-2.98,13.19-14.273,26.539-32.535,26.539c-6.414,0-14.09,0-20.5,0L623.916,1.04
			c6.408,0,14.086,0,20.502,0C662.306,1.04,667.191,13.789,664.285,26.686z M623.31,43.755h10.734
			c11.854,0,18.648-8.646,20.492-17.143c1.748-8.13-1.051-16.255-12.381-16.255h-10.734L623.31,43.755z"/>
		<path fill="inherit" d="M703.234,53.225h-39.063c4.217-17.368,8.451-34.816,12.67-52.185h39.063l-2.318,9.544h-29.299
			l-2.912,12.003h28.254l-2.223,9.165h-28.258l-2.861,11.782h29.299L703.234,53.225z"/>
		<path fill="inherit" d="M758.912,1.04h10.811l-0.107,0.446l-23.826,25.347l11.857,26.092l-0.074,0.3h-11.031l-8.582-19.607
			l-18.109,19.607H708.82l0.072-0.3l24.447-26.092L721.902,1.486l0.107-0.446h10.811l8.322,19.455L758.912,1.04z"/>
	</g>
	<g>
		<path fill="inherit" d="M97.888,14.976L76.751,2.779c0,0-36.285,5.918-68.601,25.501C8.15,28.28,69.615,8.57,97.888,14.976z"/>
		<path fill="inherit" d="M0,32.879c0,0,71.166-23.727,129.487-12.438c0,0-5.263,19.48-27.088,31.644
			c0,0,20.506-21.374-13.452-22.188C48.786,27.69,0,32.879,0,32.879z"/>
	</g>
` };
const LOGO_ICON_ONLY = { __html: `
	<svg viewBox="-127.256 -48.455 384 146.213" width="384" xmlns="http://www.w3.org/2000/svg" alt="">
		<g fill="inherit">
			<path
				d="m163.031-12.285-31.341-18.084-31.334-18.086s-26.903 4.387-65.787 16.037c-38.88 11.647-89.739 30.553-137.655 59.589 0 0 45.569-14.611 101.619-26.851 56.047-12.238 122.576-22.102 164.498-12.605z" />
			<path
				d="m-127.256 40.81s52.762-17.592 127.142-30.998c74.382-13.406 170.382-22.629 256.858-5.89 0 0-3.901 14.443-15.895 33.391-11.99 18.953-32.078 42.411-64.434 60.445 0 0 15.202-15.84 17.818-31.988 2.609-16.148-7.364-32.605-57.72-33.806-59.546-3.27-125.49-1.062-176.543 1.972-51.058 3.027-87.226 6.874-87.226 6.874z" />
		</g>
	</svg>
` };
//# sourceMappingURL=charter-index-logo.js.map